import React from "react";

import ReportingFilters from "@src/reporting/components/ReportingFilters";
import ReportingApplicationsWidget from "@src/reporting/widgets/ReportingApplicationsWidget";
import { can } from "@src/security/permissions";
import { REPORT_MODES } from "@src/reporting/model/reportingConstants.mjs";
import {
  cloneReportingFilter,
  createEmptyReportingFilter,
  reportingFilterForMode,
} from "@src/reporting/model/reportingFilters.mjs";
import DemographicsWidget from "@src/reporting/widgets/DemographicsWidget";
import DepartmentCapacityUseWidget from "@src/reporting/widgets/DepartmentCapacityUseWidget";
import GeographyDistributionWidget from "@src/reporting/widgets/GeographyDistributionWidget";
import RegistrationTimelineWidget from "@src/reporting/widgets/RegistrationTimelineWidget";
import ReportingSummaryWidget from "@src/reporting/widgets/ReportingSummaryWidget";

import styles from "@src/reporting/Reporting.module.styl";

const ReportingOverviewPage = ({ gui }) => {
  const [reportMode, setReportMode] = React.useState(REPORT_MODES.STANDARD);
  const [draftFilter, setDraftFilter] = React.useState(createEmptyReportingFilter);
  const [appliedFilter, setAppliedFilter] = React.useState(createEmptyReportingFilter);
  const [refreshToken, setRefreshToken] = React.useState(0);

  const apply = (nextFilter) => {
    const cloned = cloneReportingFilter(nextFilter);
    setDraftFilter(cloned);
    setAppliedFilter(cloned);
    setRefreshToken((value) => value + 1);
  };

  const changeReportMode = (nextMode) => {
    setReportMode(nextMode);
    setRefreshToken((value) => value + 1);
  };

  const reportFilter = reportingFilterForMode(appliedFilter, reportMode);

  return (
    <div className={styles.page}>
      <ReportingFilters
        gui={gui}
        mode="overview"
        reportMode={reportMode}
        value={draftFilter}
        onChange={setDraftFilter}
        onApply={apply}
        onReportModeChange={changeReportMode}
      />

      <ReportingSummaryWidget
        filter={reportFilter}
        refreshToken={refreshToken}
        compact
      />

      {(reportFilter.dateFrom || reportFilter.dateTo) && can(gui, "SEARCH_VOTER_APPLICATION") ? (
        <ReportingApplicationsWidget
          gui={gui}
          filter={reportFilter}
          refreshToken={refreshToken}
        />
      ) : null}

      <RegistrationTimelineWidget
        filter={reportFilter}
        refreshToken={refreshToken}
        compact
      />

      <div className={styles.overviewGrid}>
        <DemographicsWidget
          filter={reportFilter}
          refreshToken={refreshToken}
          compact
        />

        <GeographyDistributionWidget
          filter={reportFilter}
          refreshToken={refreshToken}
          initialLevel="DEPARTMENT"
          compact
          showMap={false}
          showTable={false}
        />

        <DepartmentCapacityUseWidget
          filter={reportFilter}
          refreshToken={refreshToken}
          compact
        />
      </div>

    </div>
  );
};

export const displayReportingOverview = (gui) => ({
  uuid: "reporting-overview",
  view: () => <ReportingOverviewPage gui={gui} />,
});

export default ReportingOverviewPage;